import { render, staticRenderFns } from "./receipt-cfg-form.vue?vue&type=template&id=7d4e1837&scoped=true&"
import script from "./receipt-cfg-form.vue?vue&type=script&lang=js&"
export * from "./receipt-cfg-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4e1837",
  null
  
)

export default component.exports